//create a page to cancel a ticket
import React, { useState, useEffect } from "react";
// import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { API_CONSTANTS } from "../../common/constants/api";
import {
  IBookedTicketList,
  IBusLocation,
  ICancelStatus,
} from "../../common/types";
import { Button, Form } from "react-bootstrap";
import InputGroup from "react-bootstrap/InputGroup";
import styles from "./my-tickets.module.scss";
import { Checkbox, Flex, Heading, Text } from "@radix-ui/themes";

const MyTickets = () => {
  const [isTicketAvailable, setIsTicketAvailable] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [otpToken, setOtpToken] = useState("");
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  // const [bookingId, setBookingId] = useState();
  const [bookedTickets, setBookedTickets] = useState<IBookedTicketList>();
  const [cancelledTickets, setCancelledTickets] = useState<ICancelStatus[]>([]);
  // const [cancelledTicketResponse, setCancelledTicketResponse] = useState<ICancelStatus[]>([]);
  const [message, setMessage] = useState("");
  const [isTicketCancelled, setIsTicketCancelled] = useState(false);
  const [isCancelError, setIsCancelError] = useState(false);
  const [allLocations, setAllLocations] = useState<IBusLocation[]>([]);

  const handleMyTickets = async () => {
    try {
      const response = await axios.post(API_CONSTANTS.CANCEL_TICKET, {
        bookingIds: cancelledTickets.map((t) => t.bookingId),
      });
      setIsTicketCancelled(true);
      setIsCancelError(!response.data.success);
      setMessage(response.data.message);
      if (response?.data?.success) {
        window.location.href = "/cancel-success";
      }
    } catch (error) {
      console.error("Error cancelling ticket:", error);
      setMessage("Failed to cancel ticket. Please try again.");
    }
  };

  const handleMobileNumberSend = async () => {
    if (mobileNumber) {
      const res = await axios.post(API_CONSTANTS.GENERATE_OTP, {
        mobileNumber: mobileNumber,
      });
      if (res.data.Status === "Success") {
        setOtpToken(res.data.Details);
        setMessage("OTP sent to your phone number.");
        setIsOtpSent(true);
      } else {
        setMessage("Failed to send OTP. Please try again.");
      }
    } else {
      setMessage("Please enter a valid phone number.");
    }
  };
  const handleOtpVerification = async () => {
    if (/^\d{6}$/.test(otp)) {
      // Simulate OTP verification
      const res = await axios.post(
        API_CONSTANTS.VERIFY_OTP_AND_GET_TICKET_LIST,
        {
          mobileNumber: mobileNumber,
          otp: otp,
          details: otpToken,
        }
      );
      if (res.data.isOtpValid) {
        setIsOtpVerified(true);
        setMessage("OTP verified successfully.");
        if (
          res.data.busBookingDetailList &&
          res.data.busBookingDetailList.length > 0
        ) {
          setBookedTickets({
            busBookingDetailList: res.data.busBookingDetailList,
          });
        }
      } else {
        setMessage("Invalid OTP. Please try again.");
      }
      if (
        res.data.busBookingDetailList &&
        res.data.busBookingDetailList.length > 0
      ) {
        setBookedTickets({
          busBookingDetailList: res.data.busBookingDetailList,
        });
      }
      // setIsTicketAvailable(true);
    } else {
      setMessage("Please enter a valid 6-digit OTP.");
    }
  };

  /* const fetchBookedTickets = async () => {
    try {
      const response = await axios.post(API_CONSTANTS.BOOKING_HISTORY);
      if (
        response.data &&
        response.data.busBookingDetailList &&
        response.data.busBookingDetailList.length > 0
      ) {
        setBookedTickets(response.data);
      } else {
        setIsTicketAvailable(false);
        setMessage("No booked tickets available for cancellation.");
      }
    } catch (error) {
      console.error("Error fetching booked tickets:", error);
      setMessage("Failed to fetch booked tickets. Please try again.");
    }
  }; */

  /* useEffect(() => {
    if (bookingId) {
      fetchBookedTickets();
    }
  }, [bookingId]); */
  // console.log("Booked Tickets:", bookedTickets);
  // console.log("Cancelled Tickets:", cancelledTickets);

  // Utility function to get busStopName from busStopId
  const getBusStopName = (busStopId: number): string => {
    const found = allLocations.find((loc) => loc.busStopId === busStopId);
    return found ? found.busStopName : "";
  };

  // use callback to toggle ticket cancellation

  const toggleTicketCancellation = (bookingId: string, isChecked: boolean) => {
    /* console.log(
      "toggleTicketCancellation:bookingId",
      bookingId,
      "isChecked",
      isChecked
    );
    console.log("Cancelled Tickets:", cancelledTickets); */
    if (isChecked) {
      setCancelledTickets((prev: any) => [...prev, { bookingId: bookingId }]);
    } else {
      setCancelledTickets((prev) =>
        prev.filter((c) => c.bookingId !== bookingId)
      );
    }
  };

  useEffect(() => {
    if (bookedTickets && bookedTickets.busBookingDetailList.length > 0) {
      setIsTicketAvailable(true);
    } else {
      setIsTicketAvailable(false);
      setMessage("No booked tickets available for cancellation.");
    }
  }, [bookedTickets]);

  useEffect(() => {
    axios.get(API_CONSTANTS.BUS_LOCATIONS).then((res) => {
      setAllLocations(res.data);
    });
  }, []);
  return (
    <div className={`container ${styles.myTicketsContainer}`}>
      <Heading as="h1" color="blue" align="center" className="my-5">
        My Tickets
      </Heading>
      {!isTicketCancelled && (
        <>
          <Form>
            <Form.Group controlId="mobileNumber">
              <InputGroup hasValidation>
                <InputGroup.Text>Phone Number</InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Enter your phone number"
                  onChange={(e) => setMobileNumber(e.target.value)}
                  required
                  isInvalid={!/^\d{10}$/.test(mobileNumber)} // Validate phone number format
                  pattern="[0-9]{10}"
                  title="Phone number must be 10 digits"
                />
                <Form.Control.Feedback type="invalid">
                  Phone number must be 10 digits
                </Form.Control.Feedback>
              </InputGroup>
              <Button
                variant="primary"
                onClick={handleMobileNumberSend}
                disabled={!mobileNumber}
                className="mt-2"
              >
                Send OTP
              </Button>
            </Form.Group>
            {isOtpSent && (
              <Form.Group controlId="otp" className="mt-3">
                <Form.Label>OTP</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter the OTP sent to your phone"
                  onChange={(e) => setOtp(e.target.value)}
                  required
                  pattern="[0-9]{6}" // Assuming OTP is 6 digits
                  title="OTP must be 6 digits"
                  className="mb-3"
                  disabled={!mobileNumber && !isOtpSent} // Disable if phone number is not entered
                />
                <Button
                  variant="primary"
                  onClick={handleOtpVerification}
                  disabled={!mobileNumber || isOtpVerified}
                  className="mt-2"
                >
                  Verify OTP
                </Button>
              </Form.Group>
            )}
          </Form>

          {message && <p className="mt-3">{message}</p>}
        </>
      )}
      {isTicketAvailable && (
        <Form>
          <h3 className="mt-4">Passanger Details</h3>
          {/* Table for large screens */}
          <div className={styles.ticketTableWrapper}>
            <table className={`table ${styles.ticketTable}`}>
              <thead>
                <tr>
                  <th>Booking Ref ID</th>
                  <th>Booking Date</th>
                  <th>Seat Number</th>
                  <th>Price</th>
                  <th>Passenger Name</th>
                  <th>Gender</th>
                  <th>Age</th>
                  <th>Cancel</th>
                </tr>
              </thead>
              <tbody>
                {bookedTickets &&
                  bookedTickets.busBookingDetailList.map((ticket: any) => (
                    <tr key={ticket.bookingId}>
                      <td>
                        {ticket.bookingRefId}
                        <br />
                        From: {getBusStopName(ticket.fromStation)} - To:{" "}
                        {getBusStopName(ticket.toStation)}
                      </td>
                      <td>{ticket.bookingDate}</td>
                      <td>{ticket.busSeatNumber}</td>
                      <td>Rs {ticket.bookingPrice}/-</td>
                      <td>{ticket.passengerName}</td>
                      <td>{ticket.passengerGender}</td>
                      <td>{ticket.passengerAge}</td>
                      <td>
                        <Text as="label" size="3">
                          <Flex as="span" gap="2">
                            <Checkbox
                              variant="soft"
                              color="blue"
                              size="3"
                              checked={ticket.checked}
                              onCheckedChange={(checked) => {
                                toggleTicketCancellation(
                                  ticket.bookingId,
                                  checked === true
                                );
                              }}
                            />{" "}
                            Cancel
                          </Flex>
                        </Text>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          {/* Cards for tablet/small screens */}
          <div className={styles.ticketCardWrapper}>
            {bookedTickets &&
              bookedTickets.busBookingDetailList.map((ticket: any) => (
                <div key={ticket.bookingId} className={styles.ticketCard}>
                  <div>
                    <strong>Booking Ref ID:</strong> {ticket.bookingRefId}
                  </div>
                  <div>
                    <strong>From:</strong> {getBusStopName(ticket.fromStation)}{" "}
                    - <strong>To: </strong>
                    {getBusStopName(ticket.toStation)}
                  </div>
                  <div>
                    <strong>Booking Date:</strong> {ticket.bookingDate}
                  </div>
                  <div>
                    <strong>Seat Number:</strong> {ticket.busSeatNumber}
                  </div>
                  <div>
                    <strong>Price:</strong> Rs {ticket.bookingPrice}/-
                  </div>
                  <div>
                    <strong>Passenger Name:</strong> {ticket.passengerName}
                  </div>
                  <div>
                    <strong>Gender:</strong> {ticket.passengerGender}
                  </div>
                  <div>
                    <strong>Age:</strong> {ticket.passengerAge}
                  </div>
                  <div>
                    <Text as="label" size="3">
                      <Flex as="span" gap="2">
                        <Checkbox
                          variant="soft"
                          color="blue"
                          size="3"
                          checked={ticket.checked}
                          onCheckedChange={(checked) => {
                            toggleTicketCancellation(
                              ticket.bookingId,
                              checked === true
                            );
                          }}
                        />{" "}
                        Cancel
                      </Flex>
                    </Text>
                  </div>
                </div>
              ))}
          </div>

          <Button
            className="mt-3"
            variant="primary"
            onClick={handleMyTickets}
            disabled={cancelledTickets.length === 0}
          >
            Cancel Ticket
          </Button>
          {!isCancelError && isTicketCancelled && (
            <p className="mt-5 text-success">Ticket cancelled successfully!</p>
          )}
          {isTicketCancelled && isCancelError && (
            <p className="mt-5 text-danger">
              {message || "Failed to cancel ticket. Please try again."}
            </p>
          )}
        </Form>
      )}
    </div>
  );
};

export default MyTickets;
